<template>
  <v-edit-dialog
    large
    @save="save"
    @open="open"
    height="350px"
    save-text="Salvar"
    cancel-text="Cancelar">
    <v-tooltip top v-if="isAtrasado">
      <template v-slot:activator="{ on }">
        <v-icon small color="warning" v-on="on">mdi-alert</v-icon>
      </template>
      <span>Entrega atrasada</span>
    </v-tooltip>
    {{ compraProduto.dataPrevisaoEntrega | date }}
    <v-icon small>
      mdi-pencil
    </v-icon>
    <template v-slot:input>
      <div class="mt-5">
        <px-date-picker dense
                        label="Previsão de entrega"
                        input-class="rounded-tag-small"
                        v-model="dataPrevisao"/>
      </div>
    </template>
  </v-edit-dialog>
</template>

<script>
import { SituacaoEntregaCompra } from 'px-business-components';
import CompraProdutoService from '@/modules/compra/compra-produto-service';
import moment from 'moment';

export default {
  props: {
    compraProduto: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dataPrevisao: null,
    };
  },
  computed: {
    isAtrasado() {
      return this.compraProduto.situacaoEntrega === SituacaoEntregaCompra.keys.PENDENTE.key
        && moment(this.compraProduto.dataPrevisaoEntrega).isBefore(moment());
    },
  },
  methods: {
    savePrevisaoEntrega() {
      CompraProdutoService.updatePrevisaoEntregaProduto(this.compraProduto.compra.id,
        this.compraProduto.id, {
          dataPrevisaoEntrega: this.dataPrevisao,
        }).then(() => {
        this.$toast('Compra atualizada', { color: 'success' });
        this.$emit('change');
      });
    },
    save() {
      this.savePrevisaoEntrega();
    },
    open() {
      this.dataPrevisao = this.compraProduto.dataPrevisaoEntrega;
    },
  },
};
</script>
